<template>
    <div class="wrapper">
        <div class="config-container">
            <div class="left">
                <span @click="toggleSideNav" class="toggle-side-nav">
                    <b-avatar size="2rem" style="background:#19212b">
                        <font-awesome-icon size="1x" :icon="'bars'" />
                    </b-avatar>
                </span>
                <img src="../../assets/icons/pdf.svg" 
                    style="width: 28px; cursor: pointer;" 
                    @click="exportToPDF"
                    v-b-tooltip.hover
                    title="Export to PDF"
                    />
            </div>
            <div class="charts-config-container">
                <div>
                    <p style="font-size: 12px;">Select Sequence</p>
                    <b-form-select @change="sequenceSelectionChanged" :options="sequenceOptions"
                        v-model="selectedSequence">
                        <template v-slot:first>
                            <b-form-select-option :value="null" disabled>Select Sequence</b-form-select-option>
                        </template>
                    </b-form-select>
                </div>

                <div>
                    <p style="font-size: 12px; margin-left: 8px;">Select Project</p>
                    <b-dropdown class="float-right ml-2 mt-1" size="sm" style="width: 300px; z-index: 3000;"
                        :text="projects.length + ' Projects, ' + selectedProjects.length + ' Selected'" block>
                        <div :style="{ paddingRight: '30px', paddingLeft: '30px', paddingTop: '6px', width: '298px' }">
                            <div style="display: flex; 
                                align-items: center; 
                                margin-bottom: 10px;
                                gap: 10px;">
                                filter: 
                                <b-form-select v-model="filterType">
                                    <b-form-select-option value="All">All</b-form-select-option>
                                    <b-form-select-option value="Rig Terrain">Rig Terrain</b-form-select-option>
                                    <b-form-select-option value="Fluid Type">Fluid Type</b-form-select-option>
                                    <b-form-select-option value="Funding Tranche">Funding
                                        Tranche</b-form-select-option>
                                    <b-form-select-option value="Project Class">Project Class</b-form-select-option>
                                    <b-form-select-option value="Lease ID">Lease ID</b-form-select-option>
                                </b-form-select>
                            </div>
                            <div style="display: flex; margin-bottom: 4px" v-if="filterType !== 'All'">
                                <b-form-select :options="filterOptions" boundary="'window'"
                                    v-model="selectedFilterOption" :bootstrap-styling="true" />
                            </div>
                            <div>
                                <b-form-checkbox style="height: 36px; margin-left: 1px;" v-model="selectAllProjects"><span
                                        style="font-size: 14px">Select
                                        all</span></b-form-checkbox>
                            </div>
                        </div>
                        <div class="scrollable-dropdown">
                            <b-form-checkbox class="ml-2 w-100" v-for="(project, index) in projects"
                                v-model="selectedProjects" :key="'p' + index" :value="project">
                                {{ project.name }}
                            </b-form-checkbox>
                        </div>
                    </b-dropdown>
                </div>
            </div>
        </div>

        <div class="header">
            <div class="stat-card">
                <div>
                    <h3 class="card-title">Projects</h3>
                    <p class="card-value">{{ Number(selectedProjects.length).toLocaleString('en-US') }}</p>
                </div>

                <div class="icon-wrapper">
                    <expenditure-icon />
                </div>
            </div>
            <div class="stat-card">
                <div>
                    <h3 class="card-title">Budget</h3>
                    <p class="card-value">{{ Number(totalBudget).toLocaleString('en-US') }}</p>
                    <p class="card-subtitle">K$</p>
                </div>

                <div class="icon-wrapper">
                    <budget-icon />
                </div>
            </div>
            <div class="stat-card">
                <div>
                    <h3 class="card-title">Expenditure</h3>
                    <p class="card-value">{{ Number(expenditure).toLocaleString('en-US') }}</p>
                    <p class="card-subtitle">K$</p>
                </div>

                <div class="icon-wrapper">
                    <projects-icon />
                </div>
            </div>
            <div class="stat-card">
                <div>
                    <h3 class="card-title">Variance</h3>
                    <p class="card-value">{{ Number(variance).toLocaleString('en-US') }}</p>
                    <p class="card-subtitle">K$</p>
                </div>

                <div class="icon-wrapper">
                    <projects-icon />
                </div>
            </div>
            <div class="stat-card">
                <div>
                    <h3 class="card-title">Status</h3>
                    <p class="card-value">{{ `${pending}/${ongoing}/${completed}` }}</p>
                    <p class="card-subtitle">pending/Ongoing/Completed</p>
                </div>

                <div class="icon-wrapper">
                    <status-icon />
                </div>
            </div>
        </div>
        
        

        <div class="charts-wrapper">
            <!-- Activity Cost Chart -->
            <div class="chart-card border">
                <div class="chart-card-header">
                    <select v-model="selectedCostDisplay">
                        <option value="project">Project</option>
                        <!-- <option value="department">Department</option>
                        <option value="activity">Activity</option> -->
                    </select>

                    <div class="card-table-button">
                        <div class="card-table-button" v-if="showActivityCostTable" @click="showActivityCostTable = false">
                            <b-icon icon="bar-chart" style="width: 13px; height: 13px; color: white;"></b-icon>
                        </div>
                        <font-awesome-icon v-else @click="showActivityCostTable = !showActivityCostTable" icon="table"
                            style="width: 14px; height: 14px; color: white" />
                    </div>
                    <div class="card-expander-button" @click.stop="() => {
                        isDialogOpen = true;
                        maximizerChart.chartData = costChartData
                        maximizerChart.chartOptions = activityCostChart.chartOptions
                        maximizerChart.chartType = 'bar-chart'
                    }">
                        <b-icon icon="arrows-angle-expand"
                            style="width: 12px; height: 12px; color: white; font-weight: 700"></b-icon>
                    </div>
                </div>
                <component id="activity-cost-chart" v-if="!showActivityCostTable" :is="'bar-chart'"
                    :options="activityCostChart.chartOptions" :chartdata="costChartData" :key="activityCostChartKey"
                    :styles="{ width: '100%', height: '100%', position: 'relative' }" />
                <div v-else>
                    <activity-cost-table :data="costChartData" :key="activityCostChartKey" />
                </div>
            </div>

            <!-- Time Chart -->
            <div class="chart-card border">
                <div class="chart-card-header">
                    <select v-model="selectedTimeDisplay">
                        <option value="project">Project</option>
                        <option value="department">Department</option>
                        <option value="activity">Activity</option>
                    </select>

                    <div class="card-table-button">
                        <div class="card-table-button" v-if="showTimeTable" @click="showTimeTable = false">
                            <b-icon icon="bar-chart" style="width: 13px; height: 13px; color: white;"></b-icon>
                        </div>
                        <font-awesome-icon v-else @click="showTimeTable = !showTimeTable" icon="table"
                            style="width: 14px; height: 14px; color: white" />
                    </div>
                    <div class="card-expander-button" @click.stop="() => {
                        isDialogOpen = true;
                        maximizerChart.chartData = timeChartData
                        maximizerChart.chartOptions = timeChart.chartOptions
                        maximizerChart.chartType = 'bar-chart'
                    }">
                        <b-icon icon="arrows-angle-expand"
                            style="width: 12px; height: 12px; color: white; font-weight: 700"></b-icon>
                    </div>
                </div>
                <!-- Chart and Spinner -->
                <div class="chart-container">
                    <!-- Chart Component -->
                    <component id="time-chart" v-if="!showTimeTable" :is="'bar-chart'" :options="timeChart.chartOptions"
                        :chartdata="timeChartData" :key="timeChartKey"
                        :styles="{ width: '100%', height: '100%', position: 'relative' }" />

                    <!-- Time Table -->
                    <div v-else>
                        <time-table v-if="timeChart.chartData.datasets.length" :data="timeChartData" :key="timeChartKey" />
                    </div>

                    <!-- Loading Spinner -->
                    <div v-if="isLoading" class="spinner-overlay">
                        <div class="spinner"></div>
                    </div>
                </div>
            </div>

            <!-- Cumulative Cost Chart -->
            <div class="chart-card border">

                <div class="chart-card-header">
                    <div class="card-table-button">
                        <div class="card-table-button" v-if="showCumulativeCostTable" @click="showCumulativeCostTable = false">
                            <b-icon icon="bar-chart" style="width: 13px; height: 13px; color: white;"></b-icon>
                        </div>
                        <font-awesome-icon v-else @click="showCumulativeCostTable = !showCumulativeCostTable" icon="table"
                            style="width: 14px; height: 14px; color: white" />
                    </div>
                    <div class="card-expander-button" @click.stop="() => {
                        isDialogOpen = true;
                        maximizerChart.chartData = cumulativeCostChartData
                        maximizerChart.chartOptions = cumulativeCostChart.chartOptions
                        maximizerChart.chartType = 'line-chart'
                    }">
                        <b-icon icon="arrows-angle-expand"
                            style="width: 12px; height: 12px; color: white; font-weight: 700"></b-icon>
                    </div>
                </div>
                <component id="cumulative-cost-table" v-if="!showCumulativeCostTable" :is="'line-chart'"
                    :options="cumulativeCostChart.chartOptions" :chartdata="cumulativeCostChartData"
                    :key="cumulativeCostChartKey" :styles="{ width: '100%', height: '100%', position: 'relative' }" />
                <div v-else>
                    <cumulative-cost-table :data="cumulativeCostChartData" :key="cumulativeCostChartKey" />
                </div>
            </div>

            <!-- Activity Time Chart -->
            <div class="chart-card border">
                <div class="chart-card-header">
                    <select v-model="selectedFrequencyChartDisplay">
                        <option value="project class">Project Class</option>
                        <option value="funding tranche">Funding Tranche</option>
                        <option value="fluid type">Fluid Type</option>
                        <option value="rig terrain">Rig Terrain</option>
                    </select>

                    <div class="card-table-button">
                        <div class="card-table-button" v-if="showFrequencyTable" @click="showFrequencyTable = false">
                            <b-icon icon="bar-chart" style="width: 13px; height: 13px; color: white;"></b-icon>
                        </div>
                        <font-awesome-icon v-else @click="showFrequencyTable = !showFrequencyTable" icon="table"
                            style="width: 14px; height: 14px; color: white" />
                    </div>
                    <div class="card-expander-button" @click.stop="() => {
                        isDialogOpen = true;
                        maximizerChart.chartData = frequencyChartData
                        maximizerChart.chartOptions = frequencyChart.chartOptions
                        maximizerChart.chartType = 'bar-chart'
                    }">
                        <b-icon icon="arrows-angle-expand"
                            style="width: 12px; height: 12px; color: white; font-weight: 700"></b-icon>
                    </div>
                </div>
                <component v-if="!showFrequencyTable" id="activity-time-chart" :is="'bar-chart'"
                    :options="frequencyChart.chartOptions" :chartdata="frequencyChartData" :key="frequencyChartKey"
                    :styles="{ width: '100%', height: '100%', position: 'relative' }" />
                <div v-else>
                    <frequency-table :data="frequencyChartData" :key="frequencyChartKey" />
                </div>
            </div>

            <!-- Rig Chart -->
            <div class="chart-card border">
                <div class="chart-card-header">
                    <select v-model="selectedRigDisplay">
                        <option value="Draw Works Rating">Draw Works Rating</option>
                        <!-- <option value="rig contract">Rig Contract</option> -->
                        <option value="Projects">Projects</option>
                        <option value="Depth">Depth</option>
                    </select>

                    <div class="card-table-button">
                        <div class="card-table-button" v-if="showRigTable" @click="showRigTable = false">
                            <b-icon icon="bar-chart" style="width: 13px; height: 13px; color: white;"></b-icon>
                        </div>
                        <font-awesome-icon v-else @click="showRigTable = !showRigTable" icon="table"
                            style="width: 14px; height: 14px; color: white" />
                    </div>
                    <div class="card-expander-button" @click.stop="() => {
                        isDialogOpen = true;
                        maximizerChart.chartData = rigChart.chartData
                        maximizerChart.chartOptions = rigChart.chartOptions
                        maximizerChart.chartType = 'bar-chart'
                    }">
                        <b-icon icon="arrows-angle-expand"
                            style="width: 12px; height: 12px; color: white; font-weight: 700"></b-icon>
                    </div>
                </div>
                <!-- Please don't touch -->
                <div style="visibility: hidden; position: absolute;">{{ rigChartData }}</div>
                <component v-if="!showRigTable" id="rig-chart" :is="'bar-chart'" :options="rigChart.chartOptions"
                    :chartdata="rigChart.chartData" :key="rigChartKey"
                    :styles="{ width: '100%', height: '100%', position: 'relative' }" />
                <div v-else>
                    <rig-data-table :data="rigChart.chartData" :key="rigChartKey" />
                </div>
            </div>

            <!-- Days on Projects Chart -->
            <div class="chart-card border">
                <div class="chart-card-header">
                    <div v-if="selectedDaysOnProjectsDisplay === 'planned time'"
                        style="margin-right: auto; display: flex; align-self: center; position: relative; top: 8px; left: 20px;">
                        <b-form-checkbox v-model="daysOnProjectsActivitiesStatus" :value="true">
                            <p>Show Activities</p>
                        </b-form-checkbox>
                    </div>

                    <select v-model="selectedDaysOnProjectsDisplay">
                        <option value="planned time">Planned Time</option>
                        <option value="actual time">Actual Time</option>
                    </select>

                    <div class="card-table-button">
                        <div class="card-table-button" v-if="showDaysOnProjectsTable" @click="showDaysOnProjectsTable = false">
                            <b-icon icon="bar-chart" style="width: 13px; height: 13px; color: white;"></b-icon>
                        </div>
                        <font-awesome-icon v-else @click="showDaysOnProjectsTable = !showDaysOnProjectsTable" icon="table"
                            style="width: 14px; height: 14px; color: white" />
                    </div>
                    <div class="card-expander-button" @click.stop="() => {
                        isDialogOpen = true;
                        maximizerChart.chartData = daysOnProjects.chartData
                        maximizerChart.chartOptions = daysOnProjects.chartOptions
                        maximizerChart.chartType = 'bar-chart'
                    }">
                        <b-icon icon="arrows-angle-expand"
                            style="width: 12px; height: 12px; color: white; font-weight: 700"></b-icon>
                    </div>
                </div>
                <div style="visibility: hidden; position: absolute;">{{ daysOnProjectsChart }}</div>
                <div class="chart-container">
                    <component v-if="!showDaysOnProjectsTable" id="days-on-projects-chart" :is="'bar-chart'"
                        :options="daysOnProjects.chartOptions" :chartdata="daysOnProjects.chartData"
                        :key="daysOnProjectsChartKey" :styles="{ width: '100%', height: '100%', position: 'relative' }" />
                    <div v-else>
                        <days-on-projects-table :data="daysOnProjects.chartData" :showActivity="daysOnProjectsActivitiesStatus" :key="daysOnProjectsChartKey" />
                    </div>

                    <!-- Loading Spinner -->
                    <div v-if="isLoading" class="spinner-overlay">
                        <div class="spinner"></div>
                    </div>
                </div>
                
            </div>
        </div>

        <div v-if="isDialogOpen" class="modal-bg" @click.self="isDialogOpen = false">
            <div class="modal">
                <component :is="maximizerChart.chartType" :options="maximizerChart.chartOptions"
                    :chartdata="maximizerChart.chartData"
                    :styles="{ width: '100%', height: '100%', position: 'relative' }" />
            </div>
        </div>
    </div>
</template>

<script>
import Bar from '../Analytics/charts/Bar.vue';
import Line from "../Analytics/charts/Line.vue"
import { defaultChartData, defaultChartOptions } from './chartUtils';
import ActivityCostTable from './tables/ActivityCostTable.vue';
import CumulativeCostTable from './tables/CumulativeCostTable.vue';
import BudgetIcon from './icons/BudgetIcon.vue';
import ExpenditureIcon from './icons/ExpenditureIcon.vue';
import ProjectsIcon from './icons/ProjectsIcon.vue';
import Exporter from "vue-chartjs-exporter";
import TimeTable from './tables/TimeTable.vue';
import FrequencyTable from './tables/FrequencyTable.vue';
import RigDataTable from './tables/RigDataTable.vue';
import DaysOnProjectTable from './tables/DaysOnProjectTable.vue';
import StatusIcon from './icons/StatusIcon.vue';

export default {
    components: {
        'bar-chart': Bar,
        'line-chart': Line,
        'cumulative-cost-table': CumulativeCostTable,
        'activity-cost-table': ActivityCostTable,
        'frequency-table': FrequencyTable,
        'time-table': TimeTable,
        'rig-data-table': RigDataTable,
        'days-on-projects-table': DaysOnProjectTable,
        'budget-icon': BudgetIcon,
        'projects-icon': ProjectsIcon,
        'expenditure-icon': ExpenditureIcon,
        'status-icon': StatusIcon,
    },
    data() {
        return {
            selectAllProjects: false,
            isDialogOpen: false,
            selectedChart: '',
            colorArray: ['#063567', '#fd7e14'],
            activityCostChartKey: 1,
            activityCostChart: {
                chartData: JSON.parse(JSON.stringify(defaultChartData)),
                chartOptions: JSON.parse(JSON.stringify(defaultChartOptions))
            },
            timeChartKey: 1,
            maximizerChart: {
                chartData: JSON.parse(JSON.stringify(defaultChartData)),
                chartOptions: JSON.parse(JSON.stringify(defaultChartOptions)),
                chartType: 'bar-chart'
            },
            timeChart: {
                chartData: JSON.parse(JSON.stringify(defaultChartData)),
                chartOptions: JSON.parse(JSON.stringify(defaultChartOptions))
            },
            cumulativeCostChartKey: 1,
            cumulativeCostChart: {
                chartData: JSON.parse(JSON.stringify(defaultChartData)),
                chartOptions: JSON.parse(JSON.stringify(defaultChartOptions))
            },
            frequencyChartKey: 1,
            frequencyChart: {
                chartData: JSON.parse(JSON.stringify(defaultChartData)),
                chartOptions: JSON.parse(JSON.stringify(defaultChartOptions))
            },
            rigChartKey: 1,
            rigChart: {
                chartData: JSON.parse(JSON.stringify(defaultChartData)),
                chartOptions: JSON.parse(JSON.stringify(defaultChartOptions))
            },
            daysOnProjectsChartKey: 1,
            daysOnProjects: {
                chartData: JSON.parse(JSON.stringify(defaultChartData)),
                chartOptions: JSON.parse(JSON.stringify(defaultChartOptions))
            },
            selectedProjects: [],
            projects: [],
            allProjects: [],
            sequences: [],
            reportsForProgects: [],
            selectedSequence: null,
            activeKpi: null,
            selectedCostDisplay: 'project',
            selectedTimeDisplay: 'project',
            selectedCumulativeCostDisplay: 'project',
            selectedFrequencyChartDisplay: 'project class',
            selectedRigDisplay: 'Projects',
            selectedDaysOnProjectsDisplay: 'planned time',
            filterType: '',
            filterOptions: [],
            selectedFilterOption: '',
            showActivityCostTable: false,
            showCumulativeCostTable: false,
            showTimeTable: false,
            showFrequencyTable: false,
            showRigTable: false,
            showDaysOnProjectsTable: false,
            isLoading: false,
            daysOnProjectsActivitiesStatus: false,
        }
    },
    methods: {
        exportToPDF() {
            // this.download_status = "Processing...";
            let activityCostChart = document.getElementById("activity-cost-chart");
            let timeChart = document.getElementById("time-chart");
            let cumulativeCostTable = document.getElementById("cumulative-cost-table");
            let activityTimeChart = document.getElementById("activity-time-chart");
            let rigChart = document.getElementById("rig-chart");
            let daysOnProjectsChart = document.getElementById("days-on-projects-chart");

            const exp = new Exporter([activityCostChart, timeChart, cumulativeCostTable, activityTimeChart, rigChart, daysOnProjectsChart]);
            exp.export_pdf().then((pdf) => {
                pdf.save("diap-manager's dashboard.pdf");
                // this.download_status = "Download Charts";
            });
            alert('Charts exported successfully')
        },
        toggleSideNav() {
            this.$store.commit('setSideNav')
        },
        getProjects(sequenceId) {
            if (!this.selectedSequence) {
                return []
            }
            let projects = this.$store.getters["projectModule/getProjectsForSequence"](sequenceId)
            if (projects.length < 1) {
                this.$store.dispatch("projectModule/getProjectsForSequence", sequenceId)
                    .then(res => {
                        this.allProjects = res.data.data
                    })
                return []
            }
            this.allProjects = projects;
            return projects
        },
        getSelectedProjects() {
            this.selectedProjects = this.$store.state.Analytics.selectedProjects
        },
        setSelectedProjects(value) {
            this.$store.commit("Analytics/updatedSelectedProjects", value)
        },
        getSequences() {
            let sequences = this.$store.getters["sequencesModule/getSequences"] || []
            if (sequences.length < 1) {
                this.$store.dispatch("sequencesModule/getAllSequence")
                    .then(res => {
                        this.sequences = res.data.data;
                    })
            } else {
                this.sequences = sequences;
            }
        },
        getSelectedSequence() {
            this.selectedSequence = this.$store.state.Analytics.selectedSequence
        },
        onSelectedProjectsChanged() {
            this.$emit('on-selected-project-changed', this.selectedProjects.length ? this.selectedProjects[0].id : null);
        },
        sequenceSelectionChanged() {
            this.selectedProjects = []
        },
        getPlanBudgetForProject(project) {
            let totalBudget = 0
            const sequence = this.sequences.find(x => String(x.id) === String(this.selectedSequence))
            if (project.costOption === 'LineItem') {
                project.activities.forEach((activity) => {
                    if (activity.budget) {
                        activity.budget.budgetLines.forEach((budgetLine) => {
                            totalBudget += budgetLine.lineValue
                        })
                    }
                });
            }else if (project.costOption === 'LumpCost') {
                if (!sequence.departments.length) return 0
                const deptIds = sequence.departments.map((d) => d.id);
                const departments = this.getDepartmentOptions.filter(d => deptIds.includes(d.id));
                totalBudget = departments.map((d) => d.approvedBudget).reduce((a, b) => a + b, 0);
            }
            else if (project.costOption === 'DailyCost') {
                totalBudget = project.approvedAFEBudget;
            }
            else if (project.costOption === 'ProjectCost') {
                if(project.approvedBudget && project.approvedBudget !== null){
                    project.approvedBudget.budgetLines.forEach((budgetLine) => {
                    totalBudget += budgetLine.lineValue
                    })
                }
            }
            return totalBudget
        },
        getCumulativePlanBudgetForProject(activities) {
            return activities.reduce((totalBudget, activity) => {
                if (activity.budget && activity.budget.budgetLines) {
                    const activityTotal = activity.budget.budgetLines.reduce((sum, budgetLine) => {
                        return sum + (budgetLine.lineValue || 0); // Add lineValue or 0 if undefined
                    }, 0);
                    return totalBudget + activityTotal;
                }
                return totalBudget; // Skip if no budget or budgetLines
            }, 0);
        },
        getActualCost(project) {
            let totalBudget = 0
            const sequence = this.sequences.find(x => String(x.id) === String(this.selectedSequence))
            const sortedReport = this.reportsForProgects.filter(report => String(report.projectId) === String(project.id)).sort((a, b) => {
                const dateA = new Date(a.reportDate);
                const dateB = new Date(b.reportDate);
                return dateA.getTime() - dateB.getTime();
            });

            if (project.costOption === 'LineItem') {
                if (project.selectedCost === 'ActualDailyCumulativeCost') {
                    const allReportByActivity = sortedReport.flatMap((report) => {
                        if (report && report.cost && report.cost.budgetLines && report.cost.budgetLines.length) {
                            return report.cost.budgetLines.reduce((a, b) => a + (b['lineValue'] || 0), 0);
                        }
                        return [];
                    });
                    totalBudget = allReportByActivity.length ? allReportByActivity.reduce((sum, value) => sum + value, 0) : 0;
                }
                else {
                    if (!project.activities.length) return 0
                    project.activities.forEach((activity) => {
                        if(activity.actualCost){
                            activity.actualCost.budgetLines.forEach((budgetLine) => {
                                totalBudget += budgetLine.lineValue
                            })
                        }
                    });
                }
            }
            else if (project.costOption === 'LumpCost') {
                if (project.selectedCost === 'ActualDailyCumulativeCost') {
                    const allReportByActivity = sortedReport.flatMap((report) => {
                        if (report && report.lumpedCosts && report.lumpedCosts.length) {
                            return report.lumpedCosts.reduce((a, b) => a + (b['lineValue'] || 0), 0);
                        }
                        return [];
                    });
                    totalBudget = allReportByActivity.length ? allReportByActivity.reduce((sum, value) => sum + value, 0) : 0;
                }
                else {
                    if (!this.project.departmentBudgets || !this.project.departmentBudgets.length) return 0
                    this.project.departmentBudgets.forEach(d => {
                        totalBudget += d.approvedBudget
                    });
                }
            }
            else if (project.costOption === 'DailyCost') {
                if (project.selectedCost === 'ActualDailyCumulativeCost') {
                    const allReportByActivity = sortedReport.flatMap((report) => {
                        if (report && report.dailyTotalCost && report.dailyTotalCost > 0) {
                            return report.dailyTotalCost;
                        }
                        return [];
                    });
                    totalBudget = allReportByActivity.length ? allReportByActivity.reduce((sum, value) => sum + value, 0) : 0;
                }
                else {
                    totalBudget = project.afeCost;
                }
            }
            else if (project.costOption === 'ProjectCost') {
                if (project.selectedCost === 'ActualDailyCumulativeCost') {
                    const allProjectReportByLineItems = sortedReport.flatMap((report) => {
                        if (report && report.projectCost && report.projectCost != null) {
                            return report.projectCost;
                        }
                        return [];
                    });
                    totalBudget = allProjectReportByLineItems.length ? allProjectReportByLineItems.reduce((sum, value) => sum + value, 0) : 0;
                }
                else {
                    totalBudget = report.projectCost.budgetLines.reduce((a, b) => a + (b['lineValue'] || 0), 0);
                }
            }
            return totalBudget
        },
        getCumulativeActualCost(activities) {
            return activities.reduce((totalCost, activity) => {
                if (activity.actualCost && activity.actualCost.budgetLines) {
                    const activityTotal = activity.actualCost.budgetLines.reduce((sum, budgetLine) => {
                        return sum + (budgetLine.lineValue || 0); // Add lineValue or 0 if undefined
                    }, 0);
                    return totalCost + activityTotal;
                }
                return totalCost; // Skip if no actualCost or budgetLines
            }, 0);
        },
        randomInt(min, max) {
            return min + Math.floor((max - min) * Math.random());
        },
        getProjectNameFromId(id) {
            return (this.$store.getters["projectModule/getProjectById"](id)).name
        },
        groupActivitiesByDepartment(data) {
            // Flatten the nested array
            const flattenedData = data.flat();

            // Group activities by departmentId
            return flattenedData.reduce((acc, activity) => {
                const departmentId = activity.departmentId;

                if (departmentId) {
                    if (!acc[departmentId]) {
                        acc[departmentId] = [];
                    }
                    acc[departmentId].push(activity);
                }

                return acc;
            }, {});
        },
        groupActivitiesByName(data) {
            // Flatten the nested array
            const flattenedData = data.flat();

            // Group activities by name
            return flattenedData.reduce((acc, activity) => {
                const name = activity.wellActivity.name;

                if (name) {
                    if (!acc[name]) {
                        acc[name] = [];
                    }
                    acc[name].push(activity);
                }

                return acc;
            }, {});
        },
        groupActivitiesByDuration(data) {
            // Flatten the nested array
            const flattenedData = data.flat();

            // Group activities by duration
            return flattenedData.reduce((acc, activity) => {
                if (activity.start && activity.end) {
                    // Calculate the duration in days
                    const startDate = new Date(activity.start);
                    const endDate = new Date(activity.end);
                    const duration = Math.ceil((endDate - startDate) / (1000 * 60 * 60 * 24));

                    // Use the duration as the key
                    if (!acc[duration]) {
                        acc[duration] = 0;
                    }
                    acc[duration] += 1;
                }

                return acc;
            }, {});
        },
        getDepartments() {
            return this.$store.dispatch('departmentModule/getDepartments')
        },
        getDepartmentById(departmentId) {
            return this.$store.getters['departmentModule/getDepartmentById'](departmentId)
        },
        calculateActualDuration(dailyReports) {
            if (dailyReports.length < 1) return 0;
            const reportDates = dailyReports.map(report => new Date(report.reportDate)).filter(date => !isNaN(date));
            if (reportDates.length < 1) return 0;
            const earliestDate = Math.min(...reportDates);
            const latestDate = Math.max(...reportDates);
            return Math.ceil((latestDate - earliestDate) / (1000 * 60 * 60 * 24)); // Convert ms to days
        },
        groupProjectsByClass(projects) {
            const grouped = {};

            projects.forEach(project => {
                // const projectClass = project.projectClass.name || "Unknown Class";
                let projectClass = ''
                if (project.projectClass) {
                    projectClass = project.projectClass.name
                } else {
                    projectClass = "Unknown Class"
                }

                // Increment count for this project class
                grouped[projectClass] = (grouped[projectClass] || 0) + 1;
            });

            return grouped;
        },
        groupProjectsByFundingName(projects) {
            const grouped = {};

            projects.forEach(project => {
                // const fundingName = project.funding?.name || "Unknown Funding";
                let fundingName = ''
                if (project.funding) {
                    fundingName = project.funding.name
                } else {
                    fundingName = "Unknown Funding"
                }

                // Increment count for this funding name
                grouped[fundingName] = (grouped[fundingName] || 0) + 1;
            });

            return grouped;
        },
        groupProjectsByFluidTypeName(projects) {
            const grouped = {};

            projects.forEach(project => {
                let fluidTypeName = ''
                if (project.funding) {
                    fluidTypeName = project.well.wellType
                } else {
                    fluidTypeName = "Unknown Fluid Type"
                }

                // Increment count for this funding name
                grouped[fluidTypeName] = (grouped[fluidTypeName] || 0) + 1;
            });

            return grouped;
        },
        groupProjectsByRigTerrain(projects) {
            const grouped = {};

            projects.forEach(project => {
                let rigTerrain = ''
                if (project.funding && project.rig) {
                    rigTerrain = project.rig.terrain
                } else {
                    rigTerrain = "Unknown Rig Terrain"
                }

                // Increment count for this funding name
                grouped[rigTerrain] = (grouped[rigTerrain] || 0) + 1;
            });

            return grouped;
        },
        groupProjectsByRigName() {
            const grouped = {};

            this.selectedProjects.forEach(project => {
                let rigName = ''
                if (project.rig) {
                    rigName = project.rig.name
                } else {
                    rigName = "Unknown Rig"
                }

                if (!grouped[rigName]) {
                    grouped[rigName] = 0;
                }

                grouped[rigName] += 1;
            });

            return grouped;
        },
        getRigContracts() {
            const selectedRigContracts = [];
            const rigs = this.allRigs.filter(rig => this.selectedProjects.map(project => project.rig.id).includes(rig.id));
            rigs.forEach(rig => {
                rig.rigContracts.forEach(contract => {
                    selectedRigContracts.push({
                        name: contract.rigContractType,
                        duration: this.calculateDuration(contract.startDate, contract.endDate)
                    });
                })
            });

            return selectedRigContracts;
        },
        getDrawWorksRating() {
            const drawWorksRating = [];
            const rigs = this.allRigs.filter(rig => this.selectedProjects.map(project => project.rig.id).includes(rig.id));
            rigs.forEach(rig => {
                drawWorksRating.push({
                    name: rig.name,
                    value: (rig && rig.minimumHPRating && rig.minimumHPRating.value) ? rig.minimumHPRating.value : 0
                })
            });

            return drawWorksRating;
        },
        getDrillDepthRating() {
            const drawWorksRating = [];
            const rigs = this.allRigs.filter(rig => this.selectedProjects.map(project => project.rig.id).includes(rig.id));
            rigs.forEach(rig => {
                drawWorksRating.push({
                    name: rig.name,
                    value: (rig && rig.minimumDrillDepth && rig.minimumDrillDepth.value) ? rig.minimumDrillDepth.value : 0
                })
            });

            return drawWorksRating;
        },
        calculateDuration(startDate, endDate) {
            // Convert the string dates into Date objects
            const start = new Date(startDate);
            const end = new Date(endDate);

            // Calculate the difference in time (milliseconds)
            const timeDifference = end - start;

            // Convert the time difference to days
            const daysDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));

            return daysDifference;
        },
        getRigs() {
            return this.$store.dispatch('rigsModule/getRigs')
        },
        computeDuration(start, end) {
            if (!start || !end) return 0;

            const startDateMill = new Date(start).getTime();
            const endDateMill = new Date(end).getTime();

            const diff = endDateMill - startDateMill;
            if (diff < 1) return 0;

            return Math.round(diff / (1000 * 3600 * 24));
        },
        computeSections2(projectToSection) {
            if (!projectToSection.activities || projectToSection.activities.length === 0) {
                return [];
            }
            let projects = [];
            let sections = [];
            let totalDays = this.computeDuration(projectToSection.start, projectToSection.end);
            const sortedList = [...projectToSection.activities].sort((a, b) => {
                return new Date(a.start).getTime() - new Date(b.start).getTime();
            });
            if (!projects.find((project) => project.id === projectToSection.id)) {
                projects.push({
                    id: projectToSection.id,
                    lineColor: '#dd0fff'
                });
            }
            sortedList.forEach((a) => {
                if (a.start !== null && a.wellActivity) {
                    let sectionDays = Math.round((this.computeDuration(a.start, a.end)));
                    const project = projects.find((x) => x.id === a.projectId)
                    const color = project && project.lineColor ? `${project.lineColor}` : '';
                    sections.push({ id: a.wellActivity.id, projectName: projectToSection.name, wellName: a.wellActivity.name, color: color, width: sectionDays });
                    const section = sections.find(x => x.id === a.wellActivity.id);
                    section.color = '#' + a.wellActivity.color;
                    // }
                }
            });
            return sections
        },

        getColorForProject(data) {
            const setting = this.settingsProject.find(x => x.propertyName.toLowerCase() === data.toLowerCase());
            if (setting) {
            return setting.backgroundColor;
            }
            return 'transparent';
        },

        getWellColorForProject(data) {
            const setting = this.settingswellFluid.find(x => x.propertyName.toLowerCase() === data.well.wellType.toLowerCase());
            if (setting) {
            return setting.backgroundColor;
            }
            return '#FF0000';
        },

        generateBarFillColor(data) {
            const sequence = this.sequences.find(x => String(x.id) === String(this.selectedSequence))
            switch (sequence.fillColor) {
            case 'Project Class':
                return data.projectClass ? this.getColorForProject(data.projectClass.name) : 'transparent'
            case 'Funding Tranche':
                return data.funding ? '#' + data.funding.lineColor : 'transparent';
            case 'Well Type':
                return data.well.wellType ? this.getWellColorForProject(data) : 'transparent'
            }
        },

        computeSections(projectToSection) {
            if (!projectToSection.activities || projectToSection.activities.length === 0) {
                return [];
            }

            let projects = [];
            let sections = [];
            const totalDays = this.computeDuration(projectToSection.start, projectToSection.end);

            const sortedList = [...projectToSection.activities].sort((a, b) => {
                return new Date(a.start).getTime() - new Date(b.start).getTime();
            });

            let lastColor = '';
            if (!projects.find((project) => project.id === projectToSection.id)) {
                const lineColor = this.generateBarFillColor(projectToSection);
                projects.push({
                    id: projectToSection.id,
                    lineColor: lineColor,
                });
                lastColor = lineColor;
            }

            let cumulativeWidth = 0; // Tracks the cumulative width of sections

            sortedList.forEach((activity) => {
                if (activity.wellActivity) {
                    const startOffset = Math.round(
                        (this.computeDuration(projectToSection.start, activity.start) / totalDays) * 100
                    );
                    const sectionWidth = Math.round(
                        (this.computeDuration(activity.start, activity.end) / totalDays) * 100
                    );

                    // Add a gap section if there is a gap between activities
                    if (startOffset > cumulativeWidth) {
                        sections.push({
                            id: null,
                            wellName: 'Unallocated',
                            color: lastColor, // Default or transparent color
                            width: startOffset - cumulativeWidth,
                        });
                    }

                    // Add the activity section
                    const project = projects.find((x) => x.id === activity.projectId);
                    const color = project.lineColor || '';
                    sections.push({
                        id: activity.wellActivity.id,
                        projectName: projectToSection.name,
                        wellName: activity.wellActivity.name,
                        color: color,
                        width: sectionWidth,
                    });

                    // Update cumulative width
                    cumulativeWidth = startOffset + sectionWidth;

                    // Update the color for selected activities
                    const section = sections.find((x) => x.id === activity.wellActivity.id);
                    if (section) {
                        section.color = '#' + activity.wellActivity.color;
                    }
                }
            });

            // Add a final gap section if the cumulative width is less than 100%
            if (cumulativeWidth < 100) {
                sections.push({
                    id: null,
                    wellName: 'Unallocated',
                    color: lastColor, // Default or transparent color
                    width: 100 - cumulativeWidth,
                });
            }
            return sections;
        },

        async getReportsForProjects(projects) {
            this.isLoading = true;
            const projectIds = projects.map(project => project.id);
            const response = await this.$store.dispatch("DailyReportModule/getReportsForProjects", projectIds)
            this.isLoading = false;
            this.reportsForProgects = response.data.data;
        },
    },
    computed: {
        daysOnProjectsChart() {
            const sections = []

            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.daysOnProjects.chartOptions.title.text = 'Days on Projects'
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.daysOnProjects.chartOptions.scales.yAxes[0].scaleLabel.labelString = 'Time (days)'

            if (!this.selectedProjects || this.selectedProjects.length === 0) {
                
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.daysOnProjects.chartData = { labels: [], datasets: [] };

                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.daysOnProjectsChartKey = this.daysOnProjectsChartKey + 1;
                return JSON.parse(JSON.stringify(this.daysOnProjects.chartData))
            }

            this.selectedProjects.forEach(project => {
                if (this.computeSections(project).length > 0) {
                    sections.push(this.computeSections(project))
                }
            })
            if (!sections.length) return sections

            let planValues = []
            let planLabels = []
            let datasetColors = []
            let datasetLabels = []
            let groupedDatasetData = []
            const tooltipArray = []

            if (this.selectedDaysOnProjectsDisplay === 'planned time') {
                // planLabels.push(sections[0].projectName)
                sections.forEach((sectionArr, index) => {
                    const labels = []
                    const values = []
                    const wellLabels = []
                    const wellColors = []
                    sectionArr.forEach(section => {
                        labels.push(section.projectName)
                        values.push(section.width)
                        tooltipArray.push({
                            name: section.projectName,
                            value: section.width,
                            index: index
                        })
                        wellLabels.push(section.wellName)
                        wellColors.push(section.color)
                    })
                    const sumOfValues = values.reduce((acc, curr) => acc + curr)
                    if (this.daysOnProjectsActivitiesStatus) {
                        planValues = values
                        datasetLabels = wellLabels
                        planLabels.push(labels[0])
                        datasetColors = [...wellColors]
                        groupedDatasetData.push({
                            planValues: planValues,
                            datasetLabels: datasetLabels,
                            datasetColors: datasetColors
                        })
                    } else {
                        planValues.push(sumOfValues)
                        planLabels.push(labels[0])
                    }
                })

                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.daysOnProjects.chartData.labels = planLabels

                if (this.daysOnProjectsActivitiesStatus) {

                    const datasets = [];
                    groupedDatasetData.forEach((group, index) => {
                        group.planValues.forEach((value, i) => {
                            datasets.push({
                                label: group.datasetLabels[i], // Individual dataset label
                                data: planLabels.map((_, labelIndex) => (labelIndex === index ? value : null)), // Align data to the correct label
                                backgroundColor: group.datasetColors[i],
                                borderColor: group.datasetColors[i],
                                borderWidth: 2,
                                stack: `Stack${index}`, // Stack key for grouping
                            });
                        });
                    });
                    // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                    this.daysOnProjects.chartData = {
                        labels: planLabels, // X-axis labels
                        datasets: datasets, // Dataset
                    };

                    // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                    this.daysOnProjects.chartOptions.legend = {
                        display: true, // Ensure the legend is displayed
                        labels: {
                            filter: (legendItem, chartData) => {
                                const datasetLabels = chartData.datasets.map(dataset => dataset.label);
                                return datasetLabels.indexOf(legendItem.text) === legendItem.datasetIndex;
                            },
                        },
                    };
                } else {
                    // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                    this.daysOnProjects.chartData.datasets = [
                        {
                            label: 'Plan',
                            lineTension: 0,
                            showLine: true,
                            borderWidth: 2,
                            borderColor: this.colorArray[0],
                            backgroundColor: this.colorArray[0],
                            data: planValues,
                        },
                    ]
                }

                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.daysOnProjectsChartKey = this.daysOnProjectsChartKey + 1;
            }
            else {
                // Fetch daily reports for all selected projects
                const allDailyReports = this.reportsForProgects;

                for (const project of this.selectedProjects) {
                    planLabels.push(project.name);
                    const projectReports = allDailyReports.filter(report => String(report.projectId) === String(project.id));

                    const actualDuration = this.calculateActualDuration(projectReports);
                    planValues.push(actualDuration);

                    // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                    this.daysOnProjects.chartOptions.scales.yAxes[0].scaleLabel.labelString = 'Time (days)'
                    // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                    this.daysOnProjects.chartData.labels = planLabels

                    // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                    this.daysOnProjects.chartData.datasets = [
                        {
                            label: 'Actual',
                            lineTension: 0,
                            showLine: true,
                            borderWidth: 2,
                            borderColor: this.colorArray[0],
                            backgroundColor: this.colorArray[0],
                            data: planValues,
                        },
                    ]
                }
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.daysOnProjectsChartKey = this.daysOnProjectsChartKey + 1;
            }

            return JSON.parse(JSON.stringify(this.daysOnProjects.chartData))
        },
        selectedProjectActivities() {
            if (!this.selectedProjects.length) return null;
            const foundProject = this.projects.find(project => project.id === this.selectedProjects[0].id)
            if (!foundProject) return []
            return foundProject.activities
        },
        sequenceOptions() {
            if (this.sequences) return this.sequences.map((s) => ({ value: s.id, text: s.name }))
            return []
        },
        totalBudget() {
            if (!this.selectedProjects.length) return 0;
            let value = 0
            this.selectedProjects.forEach((project) => {
                value += this.getPlanBudgetForProject(project)
            })
            return value;
        },
        expenditure() {
            if (!this.selectedProjects.length) return 0;
            let value = 0
            this.selectedProjects.forEach((project) => {
                value += this.getActualCost(project)
            })
            return value;
        },
        variance() {
            if (!this.selectedProjects.length) return 0;
            return this.totalBudget - this.expenditure;
        },
        status() {
            if (!this.selectedProjects.length) return 0;
            return this.completed;
        },
        costChartData() {
            // Plan
            let planLabels = []
            let planValues = []
            if (this.selectedCostDisplay === 'project') {
                for (let project of this.selectedProjects) {
                    planLabels.push(project.name);
                    planValues.push(this.getPlanBudgetForProject(project))
                }
            }

            // Actual
            let actualLabels = []
            let actualValues = []
            let actualBackgroundColors  = []
            let hasNonLineItem = false
            if (this.selectedCostDisplay === 'project') {
                for (let project of this.selectedProjects) {
                    actualLabels.push(project.name);
                    actualValues.push(this.getActualCost(project))
                    if (project.selectedCost === 'ActualDailyCumulativeCost') {
                        actualBackgroundColors.push('#fd7e14');
                    } else {
                        actualBackgroundColors.push('#d19a4a');
                        hasNonLineItem = true;
                    }   
                }
            }

            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.activityCostChart.chartOptions.title.text = 'Cost (Planned and Actual)'
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.activityCostChart.chartOptions.scales.yAxes[0].scaleLabel.labelString = 'Cost (K$)'
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.activityCostChart.chartData.labels = actualLabels
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.activityCostChart.chartData.datasets = [
                {
                    label: 'Plan',
                    lineTension: 0,
                    showLine: true,
                    borderWidth: 2,
                    borderColor: this.colorArray[0],
                    backgroundColor: this.colorArray[0],
                    data: planValues
                },
                {
                    label: 'Actual',
                    lineTension: 0,
                    showLine: true,
                    borderWidth: 2,
                    borderColor: actualBackgroundColors,
                    backgroundColor: actualBackgroundColors,
                    data: actualValues
                },
            ]

            // Dynamically update the legend if there is a non-LineItem selectedCost
            if (hasNonLineItem) {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.activityCostChart.chartOptions.legend = {
                    display: true, // Ensure the legend is displayed
                    labels: {
                        filter: (legendItem, chartData) => {
                            // Always show the Plan and Actual legends
                            if (legendItem.text === 'Plan' || legendItem.text === 'Actual') {
                                return true;
                            }
                            // Add a new legend entry for non-LineItem selectedCost
                            if (legendItem.text === 'Budget - Actual') {
                                return true;
                            }
                            return false;
                        },
                        generateLabels: (chart) => {
                            const defaultLabels = Chart.defaults.global.legend.labels.generateLabels(chart);
                            // Add a new legend entry for non-LineItem selectedCost
                            if (hasNonLineItem) {
                                defaultLabels.push({
                                    text: 'Budget - Actual',
                                    fillStyle: '#d19a4a', // Color for non-LineItem
                                    hidden: false, // Ensure it's visible
                                    lineCap: 'butt',
                                    lineDash: [],
                                    lineDashOffset: 0,
                                    lineJoin: 'miter',
                                    lineWidth: 1,
                                    strokeStyle: '#d19a4a',
                                    pointStyle: 'circle',
                                    rotation: 0,
                                });
                            }
                            return defaultLabels;
                        }
                    }
                };
            }

            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.activityCostChartKey = this.activityCostChartKey + 1;
            return JSON.parse(JSON.stringify(this.activityCostChart.chartData));
        },
        cumulativeCostChartData() {
            // Plan
            let planLabels = ['']
            let planValues = [0]
            if (this.selectedCumulativeCostDisplay === 'project') {
                let value = 0
                for (let project of this.selectedProjects) {
                    planLabels.push(project.name);
                    value += this.getPlanBudgetForProject(project);
                    planValues.push(value)
                }
            }

            // Actual
            let actualLabels = ['']
            let actualValues = [0]
            let cumValue = 0
            if (this.selectedCumulativeCostDisplay === 'project') {
                for (let project of this.selectedProjects) {
                    actualLabels.push(project.name);
                    cumValue += this.getActualCost(project);
                    actualValues.push(cumValue)
                }
            }

            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.cumulativeCostChart.chartOptions.title.text = 'Cumulative Cost (Planned and Actual)'
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.cumulativeCostChart.chartOptions.scales.yAxes[0].scaleLabel.labelString = 'Cost (K$)'
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.cumulativeCostChart.chartData.labels = actualLabels
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.cumulativeCostChart.chartData.datasets = [
                {
                    label: 'Plan',
                    lineTension: 0,
                    showLine: true,
                    borderWidth: 2,
                    borderColor: this.colorArray[0],
                    backgroundColor: 'transparent',
                    data: planValues
                },
                {
                    label: 'Actual',
                    lineTension: 0,
                    showLine: true,
                    borderWidth: 2,
                    borderColor: this.colorArray[1],
                    backgroundColor: 'transparent',
                    data: actualValues
                },
            ]

            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.cumulativeCostChartKey = this.cumulativeCostChartKey + 1;
            return JSON.parse(JSON.stringify(this.cumulativeCostChart.chartData));
        },
        timeChartData() {
            const planLabels = [];
            const planValues = [];
            const actualLabels = [];
            const actualValues = [];

            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.timeChart.chartOptions.title.text = 'Time (Planned and Actual)'
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.timeChart.chartOptions.scales.yAxes[0].scaleLabel.labelString = 'Time (Days)'


            if (!this.selectedProjects || this.selectedProjects.length === 0) {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.timeChart.chartData = { labels: [], datasets: [] };

                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.timeChartKey = this.timeChartKey + 1;
                return JSON.parse(JSON.stringify(this.timeChart.chartData))
            }

            const allDailyReports = this.reportsForProgects;

            // Plan and Actual for Projects, Departments, and Activities
            if (this.selectedTimeDisplay === 'project') {
                for (const project of this.selectedProjects) {
                    planLabels.push(project.name);
                    actualLabels.push(project.name);

                    // Planned duration for the project
                    const plannedDuration = project.activities.reduce((total, activity) => {
                        const start = new Date(activity.start);
                        const end = new Date(activity.end);
                        return total + (isNaN(start) || isNaN(end) ? 0 : (end - start) / (1000 * 60 * 60 * 24));
                    }, 0);
                    planValues.push(plannedDuration);

                    // Actual duration for the project
                    const projectReports = allDailyReports.filter(report => String(report.projectId) === String(project.id));

                    const actualDuration = this.calculateActualDuration(projectReports);
                    actualValues.push(actualDuration);
                }
            } else if (this.selectedTimeDisplay === 'department') {
                const allActivities = this.selectedProjects.flatMap(project => project.activities);
                const groupedByDepartment = this.groupActivitiesByDepartment(allActivities);

                for (const [deptId, activities] of Object.entries(groupedByDepartment)) {
                    const department = this.getDepartmentById(deptId);
                    planLabels.push(department.name);
                    actualLabels.push(department.name);

                    // Planned duration for the department
                    const plannedDuration = activities.reduce((total, activity) => {
                        const start = new Date(activity.start);
                        const end = new Date(activity.end);
                        return total + (isNaN(start) || isNaN(end) ? 0 : (end - start) / (1000 * 60 * 60 * 24));
                    }, 0);
                    planValues.push(plannedDuration);

                    // Actual duration for the department
                    const departmentReports = allDailyReports.filter(report =>
                        activities.some(activity => activity.id === report.activityId)
                    );
                    const actualDuration = this.calculateActualDuration(departmentReports);
                    actualValues.push(actualDuration);
                }
            } else {
                const allActivities = this.selectedProjects.flatMap(project => project.activities);
                const groupedByActivityName = this.groupActivitiesByName(allActivities);

                for (const [activityName, activities] of Object.entries(groupedByActivityName)) {
                    planLabels.push(activityName);
                    actualLabels.push(activityName);

                    // Planned duration for the activity
                    const plannedDuration = activities.reduce((total, activity) => {
                        const start = new Date(activity.start);
                        const end = new Date(activity.end);
                        return total + (isNaN(start) || isNaN(end) ? 0 : (end - start) / (1000 * 60 * 60 * 24));
                    }, 0);
                    planValues.push(plannedDuration);

                    // Actual duration for the activity
                    const activityReports = allDailyReports.filter(report =>
                        activities.some(activity => activity.id === report.activityId)
                    );
                    const actualDuration = this.calculateActualDuration(activityReports);
                    actualValues.push(actualDuration);
                }
            }

            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            // this.timeChart.chartOptions.scales.xAxes[0].scaleLabel.labelString = 'Projects'
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.timeChart.chartData.labels = planLabels
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.timeChart.chartData.datasets = [
                {
                    label: 'Plan',
                    lineTension: 0,
                    showLine: true,
                    borderWidth: 2,
                    borderColor: this.colorArray[0],
                    backgroundColor: this.colorArray[0],
                    data: planValues
                },
                {
                    label: 'Actual',
                    lineTension: 0,
                    showLine: true,
                    borderWidth: 2,
                    borderColor: this.colorArray[1],
                    backgroundColor: this.colorArray[1],
                    data: actualValues
                },
            ]

            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.timeChartKey = this.timeChartKey + 1;
            return this.timeChart.chartData
        },
        frequencyChartData() {
            const groupedProjectClassData = this.groupProjectsByClass(this.selectedProjects)
            const projectClassLabels = Object.keys(groupedProjectClassData)
            const projectClassValues = Object.values(groupedProjectClassData)

            const groupedFundingTrancheData = this.groupProjectsByFundingName(this.selectedProjects)
            const fundingTrancheLabels = Object.keys(groupedFundingTrancheData)
            const fundingTrancheValues = Object.values(groupedFundingTrancheData)

            const groupedFluidTypeData = this.groupProjectsByFluidTypeName(this.selectedProjects)
            const fluidTypeLabels = Object.keys(groupedFluidTypeData)
            const fluidTypeValues = Object.values(groupedFluidTypeData)

            const groupedRigTerrainData = this.groupProjectsByRigTerrain(this.selectedProjects)
            const rigTerrainLabels = Object.keys(groupedRigTerrainData)
            const rigTerrainValues = Object.values(groupedRigTerrainData)

            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.frequencyChart.chartOptions.title.text = 'Frequency'
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.frequencyChart.chartOptions.scales.yAxes[0].scaleLabel.labelString = 'Count'

            if (this.selectedFrequencyChartDisplay === 'project class') {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.frequencyChart.chartData.labels = projectClassLabels
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.frequencyChart.chartData.datasets = [
                    {
                        label: 'Project Class',
                        lineTension: 0,
                        showLine: true,
                        borderWidth: 2,
                        borderColor: this.colorArray[0],
                        backgroundColor: this.colorArray[0],
                        data: projectClassValues
                    }]
            }
            else if (this.selectedFrequencyChartDisplay === 'funding tranche') {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.frequencyChart.chartData.labels = fundingTrancheLabels
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.frequencyChart.chartData.datasets = [
                    {
                        label: 'Funding Tranche',
                        lineTension: 0,
                        showLine: true,
                        borderWidth: 2,
                        borderColor: this.colorArray[1],
                        backgroundColor: this.colorArray[1],
                        data: fundingTrancheValues
                    },
                ]
            }
            else if (this.selectedFrequencyChartDisplay === 'fluid type') {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.frequencyChart.chartData.labels = fluidTypeLabels
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.frequencyChart.chartData.datasets = [
                    {
                        label: 'Fluid Type',
                        lineTension: 0,
                        showLine: true,
                        borderWidth: 2,
                        borderColor: this.colorArray[1],
                        backgroundColor: this.colorArray[1],
                        data: fluidTypeValues
                    },
                ]
            }
            else {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.frequencyChart.chartData.labels = rigTerrainLabels
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.frequencyChart.chartData.datasets = [
                    {
                        label: 'Rig Terrain',
                        lineTension: 0,
                        showLine: true,
                        borderWidth: 2,
                        borderColor: this.colorArray[1],
                        backgroundColor: this.colorArray[1],
                        data: rigTerrainValues
                    },
                ]
            }

            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.frequencyChartKey = this.frequencyChartKey + 1;
            return this.frequencyChart.chartData
        },
        rigChartData() {
            let labels = []
            let values = []

            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.rigChart.chartOptions.title.text = 'Rig Data'
            if (this.selectedRigDisplay.toLowerCase() === 'draw works rating') {
                const drawWorksRating = this.getDrawWorksRating()
                labels = drawWorksRating.map(contract => contract.name)
                values = drawWorksRating.map(contract => contract.value)

            } else if (this.selectedRigDisplay.toLowerCase() === 'rig contract') {
                const rigContracts = this.getRigContracts()
                labels = rigContracts.map(contract => contract.name)
                values = rigContracts.map(contract => contract.duration)

            } else if (this.selectedRigDisplay.toLowerCase() === 'depth') {
                const drillingDepth = this.getDrillDepthRating()
                labels = drillingDepth.map(contract => contract.name)
                values = drillingDepth.map(contract => contract.value)
            } else {
                const groupedRigs = this.groupProjectsByRigName()
                labels = Object.keys(groupedRigs)
                values = Object.values(groupedRigs)
            }

            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.rigChart.chartOptions.scales.yAxes[0].scaleLabel.labelString = this.selectedRigDisplay
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.rigChart.chartData.labels = labels
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.rigChart.chartData.datasets = [
                {
                    label: '',
                    lineTension: 0,
                    showLine: true,
                    borderWidth: 2,
                    borderColor: this.colorArray[1],
                    backgroundColor: this.colorArray[1],
                    data: values
                },
            ]

            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.rigChartKey = this.rigChartKey + 1
            return JSON.parse(JSON.stringify(this.rigChart.chartData));
        },

        allRigs() {
            return this.$store.getters['rigsModule/getAllrigs']
        },
        costProjectData() {
            const labels = []
            const values = []

            for (let project of this.projects) {
                labels.push(project.name);
                values.push(this.getPlanBudgetForProject(project))
            }
            return {
                names: labels,
                values: values
            }
        },
        costDepartmentData() {
            const allActivities = this.projects.map(project => project.activities)
            const groupedActivitiesByDeptId = this.groupActivitiesByDepartment(allActivities);
            const labels = Object.keys(groupedActivitiesByDeptId).map(id => this.getDepartmentById(id).name)
            const values = Object.keys(groupedActivitiesByDeptId).map(key => this.getPlanBudgetForProject(groupedActivitiesByDeptId[key]))

            return {
                labels,
                values
            }
        },
        actualCostProjectData() {
            const namesArray = []
            const valuesArray = []
            for (let project of this.projects) {
                namesArray.push(project.name);
                valuesArray.push(this.getActualCost(project))
            }
            return {
                names: namesArray,
                values: valuesArray
            }
        },
        actualCostDepartmentData() {
            const allActivities = this.projects.map(project => project.activities)
            const groupedActivitiesByDeptId = this.groupActivitiesByDepartment(allActivities);
            const departmentNames = Object.keys(groupedActivitiesByDeptId).map(id => this.getDepartmentById(id).name)
            const values = Object.keys(groupedActivitiesByDeptId).map(key => this.getActualCost(groupedActivitiesByDeptId[key]))

            return {
                departmentNames,
                values
            }
        },

        kpis() {
            return this.$store.getters["Analytics/getKPIs"]
        },
        kpi() {
            return this.$store.getters["Analytics/getKPIById"](this.activeKpi.id)
        },
        fluidType() {
            return this.$store.getters['settingsModule/getSettingsWell'].map((setting) => {
                return setting.propertyName;
            })
        },
        fundingMechanism() {
            return this.$store.getters['fundingsModule/getFundings'].map((f) => {
                return f.name;
            })
        },
        projectClass() {
            return this.$store.getters['settingsModule/getSettingsProject'].map((setting) => {
                return setting.propertyName;
            })
        },
        rigTerrain() {
            return this.$store.getters['settingsModule/getSettingsRig'].map((setting) => {
                return setting.propertyName;
            })
        },
        getWellsAction () {
            return this.$store.dispatch('wellsModule/getWellsAction')
        },
        filteredWells () {
            return this.$store.getters['wellsModule/filteredWells']
        },
        leaseId() {
            return Array.from(new Set(this.filteredWells('').map(well => well.leaseId)));
        },
        settingswellFluid() {
            return this.$store.getters['settingsModule/getSettingsWell']
        },
        settingsProject() {
            return this.$store.getters['settingsModule/getSettingsProject']
        },
        pending() {
            const status = this.selectedProjects.filter(project => project.projectStatus == 'Pending');    
            return status.length ? status.length : 0;
        },
        ongoing() {
            const status = this.selectedProjects.filter(project => project.projectStatus == 'Ongoing');    
            return status.length ? status.length : 0;
        },
        completed() {
            const status = this.selectedProjects.filter(project => project.projectStatus == 'Completed');    
            return status.length ? status.length : 0;
        },
        getDepartmentOptions() {
            return this.$store.getters['departmentModule/getAllDepartments']
        },

    },
    mounted() {
        this.getSequences()
        if (this.filteredWells('').length < 1) {
            this.getWellsAction;
        }
        this.$store.dispatch("Analytics/getKPIs")
        this.getDepartments()
        this.getRigs()
        if (this.fluidType.length < 1 || this.projectClass.length < 1)
            this.$store.dispatch('settingsModule/getColorSettings')
        if (this.fundingMechanism.length < 1) this.$store.dispatch("fundingsModule/fetchFundings")
    },
    watch: {
        selectedSequence: {
            handler() {
                this.getProjects(this.selectedSequence);
                const savedSequence = localStorage.getItem('selectedSequence');
                if (savedSequence && this.selectedSequence !== savedSequence) {
                    localStorage.removeItem('selectedProjects');
                }
                localStorage.setItem('selectedSequence', this.selectedSequence);
            }
        },
        selectAllProjects: {
            handler() {
                if (this.selectAllProjects) {
                    return this.selectedProjects = JSON.parse(JSON.stringify(this.projects))
                } else {
                    this.selectedProjects = []
                }
                if (this.selectedProjects.length !== this.projects.length) {
                    this.selectAllProjects = false
                }
            }
        },
        selectedProjects: {
            handler(value) {
                if (value.length) {
                    this.getReportsForProjects(value);
                    localStorage.setItem('selectedProjects', JSON.stringify(value));
                }
                else {
                    this.reportsForProgects = [];
                }             
            }
        },
        filterType: {
            handler() {
                switch (this.filterType) {
                    case 'Rig Terrain':
                        this.filterOptions = this.rigTerrain;
                        this.selectedFilterOption = 'Land';
                        this.projects = this.allProjects.filter(project => String(project.rig.terrain).toLowerCase() === this.selectedFilterOption.toLowerCase())
                        break;
                    case 'Fluid Type':
                        this.filterOptions = this.fluidType;
                        this.selectedFilterOption = this.filterOptions[0];
                        break;
                    case 'Funding Tranch':
                        this.filterOptions = this.fundingMechanism;
                        this.selectedFilterOption = this.filterOptions[0];
                        break;
                    case 'Project Class':
                        this.filterOptions = this.projectClass;
                        this.selectedFilterOption = this.filterOptions[0];
                        break;
                    case 'Lease ID':
                        this.filterOptions = this.leaseId;
                        this.selectedFilterOption = this.filterOptions[0];
                        break;
                    default:
                        this.projects = this.allProjects
                        break;
                }
            }
        },
        allProjects: {
            handler() {
                this.projects = this.allProjects;
                this.filterType = 'All';
                const selectedProjects = JSON.parse(localStorage.getItem('selectedProjects'));
                if (this.projects.length && !this.selectedProjects.length && selectedProjects) {
                    this.selectedProjects = selectedProjects;
                }
            }
        },
        selectedFilterOption: {
            handler() {
                switch (this.filterType) {
                    case 'Rig Terrain':
                        this.projects = this.allProjects.filter(project => project.rig !== null && String(project.rig.terrain).toLowerCase() === this.selectedFilterOption.toLowerCase());
                        break;
                    case 'Fluid Type':
                        this.projects = this.allProjects.filter(project => project.well !== null && String(project.well.wellType).toLowerCase() === this.selectedFilterOption.toLowerCase());
                        break;
                    case 'Funding Tranch':
                        this.projects = this.allProjects.filter(project => project.funding !== null && String(project.funding.name).toLowerCase() === this.selectedFilterOption.toLowerCase());
                        break;
                    case 'Project Class':
                        this.projects = this.allProjects.filter(project => {
                            if (project.projectClass && project.projectClass !== null) {
                                return String(project.projectClass.name).toLowerCase() === this.selectedFilterOption.toLowerCase()
                            }
                        });
                        break;
                    case 'Lease ID':
                        this.projects = this.allProjects.filter(project => {
                            if (project.well && project.well !== null) {
                                return String(project.well.leaseId).toLowerCase() === this.selectedFilterOption.toLowerCase()
                            }
                        });
                        break;
                    default:
                        break;
                }
            },
            immediate: true,
        },
        sequenceOptions: {
            handler(value) {
                const selectedSequence = localStorage.getItem('selectedSequence');
                if (value.length && !this.selectedSequence && selectedSequence) {
                    const sequenceExist = this.sequenceOptions.find(x => x.value == selectedSequence);
                    if (sequenceExist) {
                        this.selectedSequence = selectedSequence;
                    }
                }
            }
        }
    }
}
</script>

<style scoped>
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

.wrapper {
    width: 100%;
    max-width: 1500px;
    margin-inline: auto;
    position: relative;
}


.config-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 1.5rem;
}

.config-container .left {
    display: flex;
    align-items: center;
    gap: 1rem;
}

.header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1.5rem;
}

.charts-config-container {
    position: relative;
    display: flex;
    gap: 1rem;
    justify-content: flex-end;
}

.stat-card {
    min-height: 150px;
    flex: 1;
    border-radius: 12px;
    background-color: #fff;
    box-shadow: 2px 2px 20px #ffffff;
    padding: 1rem;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    border: 1px solid #ddd;
    gap: 1rem;
}

.stat-card .icon-wrapper {
    flex: 1;
    height: 100px;
    display: flex;
    justify-content: flex-end
}

.card-title {
    font-size: 1.5rem;
    font-weight: 600;
    opacity: 0.8;
}

.card-value {
    font-size: 2rem;
    color: #19212b;
    font-weight: 700;
}

.card-subtitle {
    font-size: 0.875rem;
    opacity: 0.8;
}

.charts-wrapper {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(550px, 1fr));
    gap: 1rem;
    margin-top: 2rem;
}

.chart-card {
    height: 400px;
    width: 100%;
    position: relative;
    border-radius: 0.75rem;
    padding: 0.5rem;
}

.chart-card-header {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
}

.chart-card-header select {
    border: 1px solid #ccc;
    border-radius: 4px;
    padding-block: 1px;
    padding-inline: 2px;
}

.card-expander-button {
    background: rgb(4, 130, 97);
    width: 24px;
    height: 24px;
    border-radius: 100%;
    z-index: 2000;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}

.card-table-button {
    background: rgb(95, 95, 226);
    width: 24px;
    height: 24px;
    border-radius: 100%;
    z-index: 2000;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}

.chart-dialog {
    width: 80vw;
    height: 80vh;
    background: white;
    border: none;
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    padding: 20px;
}

.large-chart {
    width: 100%;
    height: 100%;
    background-color: red;
}

.modal-bg {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 9999;
}

.modal {
    background: white;
    border-radius: 8px;
    height: 90vh;
    width: 90vw;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    padding: 1.5rem;
}


.scrollable-dropdown {
    height: 500px;
    overflow-y: auto;
    overflow-x: hidden;
    padding-inline: 1.5rem !important;
    position: relative;
}

.custom-select {
    padding-inline: 1.5rem !important;
}

.empty-view {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 400px;
    padding: 2rem;
}

.empty-view p {
    max-width: 300px;
    text-align: center;
    opacity: 0.8;
}

.spinner-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: transparent;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
}

.spinner {
    width: 50px;
    height: 50px;
    border: 5px solid rgba(0, 0, 0, 0.1);
    border-top: 5px solid #3498db;
    border-radius: 50%;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

</style>
